import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default ({
  title,
  ...extra
}) => /*#__PURE__*/_jsxs("svg", {
  height: "50",
  width: "39.322",
  viewBox: "0 0 39.322 50",
  ...extra,
  children: [title, /*#__PURE__*/_jsx("path", {
    d: "M17.855 5.9c2.1 1.35 5.45 3.65 8.7 6.9 6.8 6.7 10 14.1 9.1 21.35-.35 3.05-1.6 5.65-3.7 7.75-1.25 1.25-2.85 2.3-4.6 3.1.15-.8.2-1.7.2-2.65 0-3.25-1.75-5.3-3.4-7.3-1.25-1.5-2.55-3.05-3.2-5.25l-1.6-5.45-4.15 3.9c-2.6 2.45-4.1 5.15-4.5 8.15-.5 3.6.7 6.9 2.1 9.3-2.05-.65-3.9-1.65-5.35-2.9-2.5-2.15-3.85-4.9-3.9-8.2-.15-5.7 2.4-8.05 5.6-11.05 3.6-3.4 8.05-7.55 8.7-17.65m-3.4-5.9v3.2c0 10.55-3.95 14.25-7.75 17.8-3.4 3.15-6.85 6.45-6.7 13.7.1 4.3 1.85 8 5.15 10.8 2.8 2.4 6.7 4 11 4.5h.25c.7 0 1.35-.4 1.7-1.05.4-.7.3-1.55-.25-2.15-1-1.15-4.25-5.35-3.65-9.95.3-2.2 1.45-4.2 3.4-6.1.85 2.9 2.55 4.9 3.9 6.5 1.5 1.75 2.6 3.05 2.6 5.05 0 1.75-.3 3.15-.85 4.2-.4.7-.3 1.5.15 2.1.4.5.95.75 1.5.75.15 0 .35 0 .5-.05 3.6-.95 6.7-2.65 9.05-5 2.65-2.65 4.25-5.95 4.7-9.8 1-8.35-2.5-16.75-10.15-24.25-5.65-5.5-11.5-8.65-11.75-8.75l-2.8-1.5z"
  })]
});